module.exports = __webpack_public_path__ + "media/images/bg-centered-picture-ee0041624a834ab09344e0a39b0ffe40.png";